// tslint:disable-next-line
import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'semantic-ui-react'
// import socketIOClient from "socket.io-client";
import axios from 'axios';
import { LineChart, XAxis, YAxis, Tooltip, CartesianGrid, Line } from 'recharts'

import './App.css';
import Icons from './core/components/Icons'

const ENDPOINT = "http://207.148.17.23/";
const LAST_100 = ENDPOINT + 'last_100'
type DatePrice = [Date, number]

function App() {
  // const [response, setResponse] = useState("");
  const [view, setView] = useState(10)
  const [last_10, setLast10] = useState<DatePrice[]>()
  const [last_100, setLast100] = useState<DatePrice[]>()
  const chartTransform = (width: number) => Math.ceil(width * 0.8);

  const [viewPrices, setViewPrices] = useState<DatePrice[]>([]);
  const parentRef = useRef(null);

  const changeView = (event: any, _: any) => {
    let selection = event.target.textContent;
    console.log(selection)
    if (selection !== view) {
      setView(Number(selection))
    }
  }

  const transformResponse = (record: DatePrice) => {
    return { time: record[0], price: record[1] }
  }

  useEffect(() => {
    // const socket = socketIOClient(ENDPOINT);
    if (view === 10 && !last_10) {
      axios.get(ENDPOINT)
        .then(response => {
          const payload = response.data.last_10_prices?.map(transformResponse)
          setLast10(payload)
          setViewPrices(payload)
        })
    } else if (view === 10 && last_10) {
      setViewPrices(last_10)
    } else if (view === 100 && !last_100) {
      axios.get(LAST_100)
        .then(response => {
          const payload = response.data.last_100_prices?.map(transformResponse)
          setLast100(payload)
          setViewPrices(payload)
        })
    } else if (view === 100 && last_100) {
      setViewPrices(last_100)
    }
    console.log(viewPrices)
  }, [parentRef, view, viewPrices, last_10, last_100])
  // socket.on("message", data => {
  //   console.log('subscribed to messaged')
  //   setResponse(data.data);
  //   console.log(data)
  // });

  return (
    <div className="App" ref={parentRef}>
      <h2>Last   <Dropdown text={view?.toLocaleString()} >
        <Dropdown.Menu >
          <Dropdown.Item text='10' key="10" onClick={changeView} />
          <Dropdown.Item text='100' key="100" onClick={changeView} />
        </Dropdown.Menu>
      </Dropdown> BTC Prices</h2>
      <div className="chart">
        <LineChart
          width={chartTransform((parentRef.current as any)?.offsetWidth)}
          height={400}
          data={viewPrices}
          margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
        >
          <XAxis dataKey="time" />
          <YAxis type="number" domain={['dataMin', 'dataMax']} />
          <Tooltip />
          <CartesianGrid stroke="#f5f5f5" strokeWidth="1" />
          <Line type="monotone" dataKey="price" stroke="#387908" strokeWidth="1.25" />
        </LineChart>

      </div>

      <Icons />

    </div>
  );
}

export default App;
